export default function () {
    return {
        terms: {
            id: null,
            content: null
        },
        errors: {
            'content': null
        },
        success: false
    }
}
